export default "__VITE_ASSET__5uOuQHOX__"